import React, { useState, useId } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
interface FaqItemProps {
  question: string;
  answer: string;
}
export function FaqItem({
  question,
  answer
}: FaqItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  const panelId = useId();
  return <article className="overflow-hidden rounded-2xl border border-brand-medium/15 bg-white shadow-sm" data-id="element-2" data-mp="1r0la2u099e5d">
      <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setIsOpen(current => !current)} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors hover:bg-[#f7faf6] focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-medium" data-id="element-3" data-mp="1d1bspr0bcdzt">
        <span className="font-display text-lg font-bold leading-snug sm:text-xl text-[#0B0B0B]" data-id="element-4" data-mp="2xgxaz2ugpa4n">
          {question}
        </span>
        <span className="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-brand-deep/10 text-brand-deep" aria-hidden="true" data-id="element-5" data-mp="32g9y7op8wj7r">
          {isOpen ? <MinusIcon className="h-5 w-5" data-id="element-6" data-mp="v42yv7yss9h4" /> : <PlusIcon className="h-5 w-5" data-id="element-7" data-mp="v1grb8bwptyw" />}
        </span>
      </button>
      {isOpen && <div id={panelId} className="px-6 pb-6 text-base leading-relaxed text-slate-600" data-id="element-8" data-mp="14t30kz4opiz0">
          {answer}
        </div>}
    </article>;
}